module.exports = __webpack_public_path__ + "static/images/components/VehicleType/images/AT-SPG-prem-tiny.d51601c5.png";


//////////////////
// WEBPACK FOOTER
// ./components/VehicleType/images/AT-SPG-prem-tiny.png
// module id = 2709
// module chunks = 11